export default __webpack_public_path__ + "static/media/sticker-p.4ed345bc.png";